module.exports = __webpack_public_path__ + "e289eeb03e2225438d25b6dccee2ec1c.svg";